<template>
  <page subpage title="Component Types">
    <template #actions>
      <toggle-switch
        v-model="active"
        label-on="Active"
        label-off="All"
        class="mr-3"
      ></toggle-switch>
      <sera-button
        icon="fa-solid fa-plus"
        text="Add Component Type"
        data-cy="add-component-type"
        @click="toggleModal"
      ></sera-button>
    </template>
    <div>
      <component-types-list :include-archived="!active"></component-types-list>
      <component-type-modal
        v-if="modalOpen"
        @hide-modal="toggleModal"
      ></component-type-modal>
    </div>
  </page>
</template>

<script>
import Page from "@/components/Page.vue";
import ToggleSwitch from "@/components/ToggleSwitch.vue";
import SeraButton from "@/components/Button.vue";
import ComponentTypesList from "@/ComponentTypes/ComponentTypesList.vue";
import ComponentTypeModal from "@/ComponentTypes/ComponentTypeModal.vue";
export default {
  components: {
    Page,
    ToggleSwitch,
    SeraButton,
    ComponentTypesList,
    ComponentTypeModal,
  },
  data() {
    return {
      active: true,
      modalOpen: false,
    };
  },
  methods: {
    toggleModal() {
      this.modalOpen = !this.modalOpen;
    },
  },
};
</script>

<style lang="scss" scoped></style>
